import CalculoBonificacao from './calculo-bonificacao.model';
import CampanhaBonificacao from './campanha-bonificacao.model';
import VerbaExtra2 from './verba-extra-2.model';

export default class ItensAprovacao {
  calculos?: CalculoBonificacao[];
  campanhas?: CampanhaBonificacao[];
  verbasExtra?: VerbaExtra2[];
}
